import React from 'react';
import TextLoop from 'react-text-loop';
import '@lottiefiles/lottie-player';
const conctInfo = {
  phone: '+91 8800237039',
  email: 'omkrjha@outlook.com',
};

const sliderContent = {
  name: 'Hari Om Kumar Jha',
  designation: 'Full-stack Developer',
  description: `A diligent and proactive Developer with experience in the Web Development and a strong foundation in
  Data Structures and Algorithms, seeking a challenging role to leverage skills and contribute effectively to development
  projects while continuously learning and growing in a professional environment.`,
  btnText: ' Download CV',
};

const Slider = () => {
  const lottieUrl =
    'https://lottie.host/35a39d28-d718-446f-b24d-1602f2503607/a5jhC6dXTX.json';
  return (
    <>
      {/*  Home Banner */}
      <section id='home' className='home-banner'>
        <div className='hb-top-fixed d-flex'>
          <div className='hb-info'>
            <a href='tel:+91 8800237039'>{conctInfo.phone}</a>
            <a href='mailto:mail%20to:omkrjha@outlook.com,com'>
              {conctInfo.email}
            </a>
          </div>
          {/* <div className="hb-lang">
            <ul className="nav">
              <li className="active">
                <a href="#">EN</a>
              </li>
              <li>
                <a href="#">FR</a>
              </li>
            </ul>
          </div> */}
        </div>
        {/* End hp-top-fixed */}

        <div className='container'>
          <div className='row full-screen align-items-center'>
            <div className='col-lg-7'>
              <div className='type-box'>
                <h6 data-aos='fade-up' data-aos-duration='1200'>
                  Hello, My name is
                </h6>
                <h1
                  className='font-alt'
                  data-aos='fade-up'
                  data-aos-duration='1200'
                  data-aos-delay='100'
                >
                  {sliderContent.name}
                </h1>
                <div
                  data-aos='fade-up'
                  data-aos-duration='1200'
                  data-aos-delay='200'
                >
                  <TextLoop>
                    <p className='loop-text lead'>
                      A Pragmatic Full Stack Developer
                    </p>
                    <p className='loop-text lead'>
                      {' '}
                      I build things for the web
                    </p>
                    {/* <p className='loop-text lead'> App Developer</p> */}
                  </TextLoop>
                </div>

                <p
                  className='desc'
                  data-aos='fade-up'
                  data-aos-duration='1200'
                  data-aos-delay='300'
                >
                  {sliderContent.description}
                </p>
                <div
                  className='mt-4'
                  data-aos='fade-up'
                  data-aos-duration='1200'
                  data-aos-delay='400'
                >
                  <a
                    className='px-btn px-btn-white'
                    href='https://drive.google.com/file/d/1uUKJ5JELGBXZq2k5L83zs6nMVxI3q4yl/view?usp=sharing'
                    target='_blank'
                    rel='noreferrer'
                    download
                  >
                    {sliderContent.btnText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Container*/}
        {/* <div
          className="hb-me"
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL + "img/slider/home-banner.png"
            })`,
          }}
        ></div> */}
        {/* <img className="hb-me" src={avatar} alt="" /> */}
        <div className='hb-me'>
          <lottie-player
            src={lottieUrl}
            background='transparent'
            speed='1'
            loop
            autoplay
          />
        </div>
      </section>

      {/* End Home Banner  */}
    </>
  );
};

export default Slider;
